export const ROUTES = {
  AVAILABLE_JOBS: "#availablejobs",
  ABOUT: "#about",
  CREATE_JOB: "#createjob",
  HOME: "#home",
  LOGIN: "#login",
  REGISTER: "#register",
  MY_JOB_REQUESTS: "#myjobrequests",
  MY_PROFILE: "#myprofile",
  UPDATE_JOB: "#updatejob",
};
